// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import AuditRecording from '@deere/cps-it.warranty-model-factory/lib/audit-recording';
import ClaimAuditItem from './claim-audit-item';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import FullDebitModal from '../../shared/components/debit-modal';
import RecordAuditHeader from './record-audit-header';
import RecordAuditModal from './record-audit-modal';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleFullDebitModalOpen(claimNumber) {

    this.actions.readDebit(claimNumber);

}

function handlePartialDebitModalOpen() {

    this.actions.updatePartialDebitModalVisibility(true);

}

function handleFullDebitModalClose() {

    this.actions.updateFullDebitModalVisibility(false);

}

function handleFullDebitCommentsChange(comments) {

    this.actions.updateFullDebitComments(comments);

}

function handleFullDebitModalConfirmation(debit) {

    this.actions.submitFullDebit(debit, this.auditRecording.auditNumber);

}

function handleConfirmationModalClose() {

    this.actions.updateConfirmationModalVisibility(false);

}

function onConfirm() {

    const endPoint = 'https://dlrdoc.deere.com/ag_cust_supp/claimDebit';

    window.open(endPoint, '_blank');

    this.actions.updateConfirmationModalVisibility(false);

}

class RecordAudit extends Component {

    componentWillMount() {

        if (this.props.queryParams.auditNumber) {

            this.props.actions.readAuditRecords(this.props.queryParams.auditNumber);

        }

    }

    componentWillUnmount() {

        this.props.actions.updateFullDebitModalVisibility(false);
        this.props.actions.updateConfirmationModalVisibility(false);

    }

    render() {

        return this.props.auditRecording.claims.length > 0 &&
            <section className='record-audit'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <RecordAuditHeader/>
                <div className='claim-audit-items'>
                    {this.props.auditRecording.claims.map((claim, index) =>
                        <ClaimAuditItem
                            auditNumber={this.props.auditRecording.auditNumber}
                            claim={claim}
                            key={index}
                            onFullDebitModalOpen={this.props::handleFullDebitModalOpen}
                            onPartialDebitModalOpen={this.props::handlePartialDebitModalOpen}
                        />
                    )}
                </div>
                <RecordAuditModal/>
                <FullDebitModal
                    busyCounter={this.props.busyCounter}
                    closeModal={this.props::handleFullDebitModalClose}
                    debit={this.props.fullDebitItemToUpdate}
                    debitType='FULL'
                    isModalVisible={this.props.isFullDebitModalVisible}
                    onCommentsChange={this.props::handleFullDebitCommentsChange}
                    onConfirmation={this.props::handleFullDebitModalConfirmation}
                />
                <ConfirmationModal
                    confirmMessage='DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS'
                    isOpen={this.props.isConfirmationModalVisible}
                    onClose={this.props::handleConfirmationModalClose}
                    onConfirm={this.props::onConfirm}
                    title='FULL_DEBIT'
                />
            </section>;

    }

}

RecordAudit.displayName = 'RecordAudit';
RecordAudit.propTypes = {
    actions: PropTypes.object.isRequired,
    auditRecording: PropTypes.instanceOf(AuditRecording).isRequired,
    busyCounter: PropTypes.number.isRequired,
    fullDebitItemToUpdate: PropTypes.instanceOf(Debit).isRequired,
    isConfirmationModalVisible: PropTypes.bool.isRequired,
    isFullDebitModalVisible: PropTypes.bool.isRequired,
    isPartialDebitModalVisible: PropTypes.bool.isRequired,
    queryParams: PropTypes.object.isRequired
};

export default RecordAudit;



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/record-audit.js